import { useContext, useEffect, useState } from 'react';
import SwitchCard from "../switch-card";
import Context from 'context/appContext';
import { getSidebarData, getBody, getDate, getValueField } from 'utils/utils';

// @styles 
import './styles.scss'
import ModalWarning from 'components/modal-warning';
import Loading from 'components/loading';

export default function BasicCard({ info }) {
    const [openMore, setOpenMore] = useState(false);
    const [loading, setLoading] = useState(false);
    const [arrayBenefits, setArrayBenefits] = useState([]);
    const [addCoverage, setAddCoverage] = useState([]);
    const [arrayView, setArrayView] = useState([]);
    const [alert, setAlert] = useState(false);
    const [coverages, setCoverages] = useState([]);
    const [showSwitchCard, setShowSwitchCard] = useState(false);
    const [errors, setErrors] = useState({});

    const { dataForm: { data, formResponses }, formStatus: { isGoToBack }, customRequest,
        insureds, setPriceToShow, setSidebarData, setPolicyNumber, setReturnButton, tokenInfo, setDisabledButtonContinue, isClassActive, setIsClassActive } = useContext(Context);
    const prismicMedia = process.env.REACT_APP_PRISMIC_URL_MEDIA;

    useEffect(() => {
        setArrayView(openMore ? arrayBenefits : arrayBenefits.slice(0, 3));
    }, [arrayBenefits]);

    useEffect(() => {
        setSidebarData(getSidebarData(insureds, formResponses));
        getValues();
    }, []);

    const validateRange = () => {
        let validationInsureds = [];
        let ranges = info && info.properties;
        let newArrayInsureds = insureds && [...insureds];
        if (insureds.length === 0 || insureds.length === 1) { // Sólo a ti  //insureds.length === 0 -> cuando sólo exite el titular antes de info. Asegurados // insureds.length === 1 -> cuando sólo es un asegurado y recuperamos trámite o avanzamos entre pantallas
            const date = getValueField('fechaNacimiento', formResponses);
            const insured = {
                age: date,
                type: 'T',
            }
            newArrayInsureds = [insured];
        }
        newArrayInsureds && newArrayInsureds.forEach((insured, index) => {
            const range = ranges[insured.type].split("-");
            const age = getDate(insured.age);
            validationInsureds[index] = Number(range[0]) <= age && age <= Number(range[1]);
        });

        const isViable = (validationInsureds.filter(x => x === false)).length !== 0; //Se filtra por validaciones fallidas -> si existe al menos una que falle [false]
        setShowSwitchCard(!isViable);
        const object = { ...isClassActive, '6637': isViable }
        setIsClassActive(object);
        return object;
    }

    const changeView = () => {
        setOpenMore(!openMore);
        setArrayView(!openMore ? arrayBenefits : arrayBenefits.slice(0, 3));
    }

    const getValues = async () => {
        setReturnButton(false);
        setLoading(true);
        setDisabledButtonContinue(true);
        const infoRequest = JSON.parse(info.content);
        const body = getBody({}, data.modelConfig, formResponses, insureds, tokenInfo, validateRange());
        const res = await customRequest(infoRequest.url, infoRequest.headers, infoRequest.method, body);
        data['infoRequote'] = { res, infoRequest };

        if (res && res.success && res.respuesta.policy) {
            const policy = res.respuesta.policy;
            setPolicyNumber(policy.policy.policyNumber);
            !isGoToBack && setPriceToShow(policy.costs.amount);
            const coveragePeople = res.respuesta && res.respuesta.coveragePeople;
            const benefit = coveragePeople && coveragePeople.filter(coverage => coverage.benefits);
            const additionalcoverages = coveragePeople && coveragePeople.filter(coverage => coverage.coverageType === "ADICIONAL");
            const situations = policy.situations && policy.situations[0];
            situations.coverages && setCoverages(situations.coverages);
            setAddCoverage(additionalcoverages);
            setArrayBenefits(benefit[0].benefits);
            setDisabledButtonContinue(false);
        } else {
            setErrors(res && res.respuesta && res.respuesta.errors);
            setAlert(true)
        }
        setReturnButton(true);
        setLoading(false);
    }

    return loading ? <Loading /> : (alert ? <ModalWarning info={{ visible: true, type: 'error', errors: errors }} /> : (
        <div className="basiccard-container">
            {arrayView && arrayView.map((benefit, index) =>
                <>
                    <div className="basiccard-container-item" id={index}>
                        <img className='basiccard-container-item-img' src={`${prismicMedia}/${benefit.image}`} alt={benefit?.title} />
                        <p className="basiccard-container-item-title">{benefit.title}</p>
                        <p className="basiccard-container-item-description">{benefit.description}</p>
                    </div>
                </>
            )}

            {arrayBenefits && arrayBenefits.length > 3 && <div className='basiccard-container-view-more'>
                <a className={`link ${openMore && 'open'}`}
                    onClick={changeView}>
                    {openMore ? 'VER MENOS' : 'VER MÁS'}
                </a>
            </div>}
            {showSwitchCard && (<SwitchCard addCoverage={addCoverage} prismicMedia={prismicMedia} coverages={coverages} />)}
        </div>))
}
